// Determines if the user has scrolled past a certain threshold
// and whether the scroll jump was significant enough to trigger animations.
export const calculateScrollState = (threshold, animationThreshold, hasScrolledPast) => {
  const currentOffset = window.pageYOffset

  if (currentOffset < threshold && hasScrolledPast) {
    return { scrolledPastPoint: false, scrollJumped: false }
  }

  if (currentOffset >= threshold && !hasScrolledPast) {
    return {
      scrolledPastPoint: true,
      scrollJumped: currentOffset - threshold > animationThreshold,
    }
  }

  return null
}

// Updates the selected recipe variants while preserving existing selections.
export const updateSelectedVariants = (originalVariants, payload) => {
  const currentVariants = originalVariants[payload.collectionId] || {}

  return {
    ...originalVariants,
    [payload.collectionId]: {
      ...Object.fromEntries(
        Object.entries(currentVariants)
          .filter(([_, value]) => value !== payload.originalRecipeId),
      ),
      ...(payload.recipeReference &&
        { [payload.recipeReference]: payload.variantId }),
    },
  }
}
